import React from 'react';
import PropTypes from 'prop-types';
import './ProTip.scss';
function ProTip(props) {
  var iconClassName = 'fas fa-magic';
  var headingText = 'ProTip';
  var backgroundColor = 'yellow';
  if (props.isExample) {
    iconClassName = 'fas fa-paperclip';
    headingText = 'Examples';
    backgroundColor = 'blue';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "sticky-note ".concat(backgroundColor, " ").concat(props.className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: iconClassName
  }), headingText), props.children);
}
ProTip.propTypes = {
  isExample: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};
ProTip.defaultProps = {
  isExample: false,
  className: ''
};
export default ProTip;